import Vue from 'vue';

export default class RestErreur extends Error {
  constructor(insMessage, inexError) {
    super();
    this.name = 'RestErreur';
    this.stack = inexError.stack ? inexError.stack : new Error().stack;
    this.success = inexError.response ? inexError.response.data.success : false;
    this.status = inexError.response ? inexError.response.status : false;
    this.statusMessage = RestErreur.getStatusMessage(this.status);
    this.message = insMessage || RestErreur.getResponseErrorMessage(inexError);
    Vue.$log.error('RestErreur', insMessage, inexError);
  }

  toString() {
    return `Message: ${this.message} status:${this.status} erreur: ${super.toString()} stack: ${this.stack}`;
  }

  /**
   * Return message for HTTP status code
   * @param {number} iniCode - HTTP status code
   * @returns {string} Message of network operation
   */
  static getStatusMessage(iniCode) {
    let sMessage = '';

    switch (iniCode) {
      case 200:
        sMessage = 'All done. Request successfully executed';
        break;
      case 201:
        sMessage = 'Data successfully created';
        break;
      case 400:
        sMessage = 'Bad Request';
        break;
      case 401:
        sMessage = 'Need auth';
        break;
      case 404:
        sMessage = 'Not found';
        break;
      case 503:
        sMessage = 'Service Unavailable';
        break;
      default:
        sMessage = 'Something wrong. Client default error message';
        break;
    }
    return sMessage;
  }

  static getResponseErrorMessage(inexError) {
    if (inexError.response && inexError.response.data) return inexError.response.data.description;
    if (inexError.response && inexError.response.statusText) return inexError.response.statusText;
    if (inexError.message) return inexError.message;
    return 'getResponseErrorMessage can\'t handle error';
  }
}
